exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recommend_custom_page .config_wrapper>div label[data-v-7ff39a41]{width:70px}.recommend_custom_page .config_wrapper .input_wrapper[data-v-7ff39a41]{margin-left:0}\n", ""]);

// exports
